import { window } from '../../../../globals';
import { queryClient, useToastedMutation } from '../../../../ReactQuery';
import { post } from '../../../../redux/api';
import type { CreateGitLabInstanceRequest } from '../../../../../shared/settings/gitlab';

import { getGitLabSettingsQueryKey } from './useGetGitLabSettings';

function createGitLabInstance(orgId: number, newInstance: CreateGitLabInstanceRequest) {
  return post<CreateGitLabInstanceRequest, void>(`/api/organizations/${orgId}/settings/integrations/gitlab`, newInstance);
}

/**
 * Creates a new GitLab instance for the organization.
 */
export default function useCreateGitLabInstance(onSuccess?: () => void) {
  return useToastedMutation({
    mutationFn: (newInstance: CreateGitLabInstanceRequest) =>
      createGitLabInstance(window.user?.organizationId ?? 0, newInstance),
    onSuccess: () => {
      queryClient.invalidateQueries(getGitLabSettingsQueryKey(window.user?.organizationId ?? 0));
      onSuccess?.();
    },
    successToastMessage: 'GitLab instance created successfully.',
    errorToastMessage: 'Failed to create GitLab instance.',
  });
}
